const convertZeroToString = data => {
  if (data === 0) {
    return '0'
  }
  return data
}

export default convertZeroToString
